import React from 'react';
import { createHashRouter, RouterProvider } from 'react-router-dom';
import App from '@/components/App';
import NotFound from '@/components/NotFound';
import routes from '@/router/routes';

const router = createHashRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <NotFound />,
    children: routes,
  },
]);

export default () => <RouterProvider router={router} />;
